import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, err: null };
  }
  static getDerivedStateFromError(err) {
    return { hasError: true, err };
  }
  componentDidCatch(err, info) {
    // lightweight console log (you can wire this into FeedbackProvider later)
    console.error("[ErrorBoundary]", err, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 16 }}>
          <h3>Something went wrong</h3>
          <p>Try going back or reloading. If this persists, check your last change.</p>
        </div>
      );
    }
    return this.props.children;
  }
}
